import React, { useState, useEffect } from "react";
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../../redux/actions/authActions';

const initialStudents = [
  { name: 'Aarav Sharma', place: 'Surat', score: 94 },
  { name: 'Sarthak Mehta', place: 'Pune', score: 92 },
  { name: 'Ishita Verma', place: 'Nagpur', score: 90 },
  { name: 'Tanvi Singh', place: 'Chandigarh', score: 89 },
  { name: 'Aditya Rao', place: 'Hyderabad', score: 87 },
  { name: 'Riya Subramanian', place: 'Coimbatore', score: 86 },
  { name: 'Dev Patel', place: 'Rajkot', score: 85 },
  { name: 'Sneha Joshi', place: 'Indore', score: 84 },
  { name: 'Karthik Nair', place: 'Bengaluru', score: 83 },
  { name: 'Priya Desai', place: 'Vadodara', score: 82 },
  { name: 'Nikhil Kulkarni', place: 'Aurangabad', score: 91 },
  { name: 'Meera Choudhary', place: 'Jaipur', score: 88 },
  { name: 'Yash Ranjan', place: 'Jamshedpur', score: 85 },
  { name: 'Pooja Tiwari', place: 'Bhopal', score: 83 },
  { name: 'Rahul Saxena', place: 'Lucknow', score: 80 }
];


const YuvaSolverScorecard = () => {
  const authState = useSelector(state => state.authReducer);
  const { isLoggedIn } = authState;
  const [userName] = useState(authState.user.name);
  const [selectedRole, setSelectedRole] = useState('Student');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const [rankings, setRankings] = useState([]);

  const shuffleAndSelectTop10 = () => {
    const shuffled = [...initialStudents]
      .sort(() => 0.5 - Math.random())
      .slice(0, 10)
      .sort((a, b) => b.score - a.score)
      .map((msme, index) => ({ rank: index + 1, ...msme }));
    setRankings(shuffled);
  };

  useEffect(() => {
    shuffleAndSelectTop10(); 
    const interval = setInterval(shuffleAndSelectTop10, 5000);
    return () => clearInterval(interval); 
  }, []);

  const today = new Date().toLocaleDateString('en-IN', {
    day: 'numeric', month: 'long', year: 'numeric'
  });

  return (
    <div className="flex flex-col min-h-screen font-sans text-white bg-black">

      <header className="flex justify-between items-center px-4 py-1 bg-black shadow-md sticky top-0 z-50 border-b border-purple-500">
        <div
          onClick={() => navigate("/rankings")}
          className="text-lg lg:text-xl font-bold text-yellow-200 tracking-wide cursor-pointer"
        >
          🧠 YUVA Solvers Rankings
        </div>

        <div className="hidden md:flex items-center space-x-2">
          {isLoggedIn && (
            <>
              <span className="text-white font-medium">{userName}</span>
              <button
                onClick={handleLogout}
                className="w-8 h-8 mt-2 flex items-center justify-center text-lg bg-blue-500 text-white rounded-full hover:bg-blue-600 transition sm:w-9 sm:h-9"
                title="Logout"
              >
                ⏻
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden mt-2 w-8 h-8 flex items-center justify-center text-xl bg-blue-700 text-white"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>        
      </header>

      {isMobileMenuOpen && (
        <nav className="md:hidden bg-black flex flex-col px-4 py-3 space-y-3">
          {isLoggedIn && (
            <div className="border-t pt-3 border-purple-500 text-white">
              <p className="mb-2 text-sm">{userName}</p>
              <button
                onClick={handleLogout}
                className="bg-blue-500 text-white mt-2 px-4 py-2 rounded text-sm hover:bg-blue-600 w-full transition"
              >
                Logout
              </button>
            </div>
          )}
        </nav>
      )}

      <main className="flex-1 bg-black text-white p-2">
        <div className="text-center mb-2">
          <p className="text-white">{today}</p>
        </div>

        <div className="overflow-x-auto bg-black shadow-md rounded-lg">
          <table className="min-w-full table-auto border border-gray-300">
            <thead className="bg-purple-200 text-blue-800">
              <tr>
                <th className="py-2 px-1 border">Rank</th>
                <th className="py-2 px-4 border">YUVA Name</th>
                <th className="py-2 px-4 border">Place</th>
                <th className="py-2 px-1 border">Score</th>
              </tr>
            </thead>
            <tbody className="bg-black transition-all duration-500">
              {rankings.map(({ rank, name, place, score }) => (
                <tr key={name} className="text-left hover:bg-purple-600 transition-all">
                  <td className="py-2 px-1 border">{rank}</td>
                  <td className="py-2 px-4 border">{name}</td>
                  <td className="py-2 px-4 border">{place}</td>
                  <td className="py-2 px-1 border font-semibold text-white">{score}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>

     <footer className="bg-black border-t border-purple-400 text-white py-2 px-4 mt-2">
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left space-y-4 md:space-y-0">
          <p className="text-xs sm:text-sm">&copy; 2025 Think5Whys Global DeepTech Solutions.</p>
          <div className="flex flex-row gap-2 sm:gap-6 text-xs sm:text-sm">
            <Link to="/about-us" className="text-white hover:text-purple-200 transition">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-purple-200 transition">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-purple-200 transition">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-purple-200 transition">Contact</Link>
          </div>
        </div>
      </footer>  
    </div>
  );
};

export default YuvaSolverScorecard;
